import React, { useState, useEffect } from "react";
import IconButton from "../IconButton";
import Button from "../Button";
import Typography from "../Typography";
import Paper from "../Paper";
import Spinner from "../Spinner";
import { MdRefresh, MdInfo, MdClose } from "react-icons/md";
import api from "../../services/api";

const packageVersion = require("../../../package.json").version;

const VersionControl = () => {
  const [storedVersion] = useState(
    window.localStorage.getItem("frontendVersion") || "4.7.7"
  );
  const [showBanner, setShowBanner] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const hasNewVersion = storedVersion !== packageVersion;

  useEffect(() => {
    if (hasNewVersion) {
      const timer = setTimeout(() => setShowBanner(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [hasNewVersion]);

  const handleUpdate = async () => {
    setIsUpdating(true);

    try {
      window.localStorage.setItem("frontendVersion", packageVersion);
      await api.post("/version", { version: packageVersion });

      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }

      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error("Erro na atualização:", error);
      setIsUpdating(false);
    }
  };

  if (!hasNewVersion) {
    return null;
  }

  return (
    <>
      {/* Banner de Atualização Centralizado */}
      {showBanner && !isUpdating && (
        <Paper
          className="fixed top-16 left-1/2 z-[1202] flex w-[95%] min-w-[300px] max-w-[600px] -translate-x-1/2 items-center justify-between !rounded-md !bg-info px-4 py-2 !text-white !shadow-[0_4px_12px_rgba(0,0,0,0.2)] sm:w-[90%] sm:min-w-[400px] sm:px-6 sm:py-3"
        >
          <div className="flex flex-1 items-center">
            <div className="mr-2 flex items-center">
              <MdInfo />
            </div>
            <Typography variant="body2">
              <strong>Nova versão {packageVersion} disponível!</strong>
              {" Clique em atualizar para obter as últimas melhorias."}
            </Typography>
          </div>
          <div className="ml-4 flex items-center gap-2">
            {isUpdating && <Spinner size={20} color="inherit" />}
            <Button
              size="sm"
              onClick={handleUpdate}
              disabled={isUpdating}
              className="!border-success !bg-success !font-bold !text-white hover:!bg-green-700"
            >
              {!isUpdating && <MdRefresh />}
              {isUpdating ? "Atualizando..." : "Atualizar"}
            </Button>
            {!isUpdating && (
              <IconButton
                size="small"
                onClick={() => setShowBanner(false)}
                className="!text-white"
              >
                <MdClose className="text-lg" />
              </IconButton>
            )}
          </div>
        </Paper>
      )}
    </>
  );
};

export default VersionControl;
